import React from 'react';
import Button from '../../common/buttons/onboarding/OnboardingButton';
import { getTitleForTier } from '../../../helpers/tiers';
import Heading, { HEADING_SIZE } from '../../common/heading/Heading';
import { proceedToPushUrl } from '../common/onboardingHelpers';
import { BUTTON_KIND_WHITE } from '../../common/buttons/button/Button';
import cx from 'classnames';
import { formatPrice } from '../../../helpers/number';
import { initiateTrackStructEvent } from '../../analytics/Snowplow';
import {
	EVT_SUBSCRIPTION_CATEGORY,
	EVT_ELEMENT_INTERACTION,
	EVT_TIER_TABLE,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_ELEMENT_STYLE_PRIMARY,
	EVT_SUBSCRIPTION_SELECT,
	EVT_TIER_TABLE_BUTTON,
} from '../../../constants/SnowplowEvents';

import './SavodTierStep.scss';

export const SavodTierStep = ({
	selectedTier,
	setSelectedSavodTier,
	selectedSavodTier,
	tierPrice,
	setIsSavodTierSelected,
	savodTierPrice,
	proceedText,
	onClickProceed,
	proceedUrl,
	setProceedButtonUrl,
}) => {
	const tierTitle = getTitleForTier(selectedTier).title;
	return (
		<div className="tier-options-savod">
			<Heading size={HEADING_SIZE.MEDIUM}>Jouw keuze</Heading>
			<div className="tier-options-savod-selection">
				<span className="tier-options-savod-selection__tier">{tierTitle}</span>
				<span
					onClick={() => {
						initiateTrackStructEvent({
							category: EVT_SUBSCRIPTION_CATEGORY,
							action: 'subscription-switch',
							label: tierTitle,

							rtlElementContext: {
								elementInteraction: EVT_ELEMENT_INTERACTION,
								elementGroup: EVT_TIER_TABLE,
								elementType: EVT_ELEMENT_TYPE_BUTTON,
								elementName: 'tier-toggle',
								elementLabel: 'Wijzig',
								elementStyle: 'toggle',
							},
						});
						setIsSavodTierSelected(false);
						setSelectedSavodTier(false);
					}}
					className="tier-options-savod-selection__change"
				>
					Wijzig
				</span>
			</div>
			<Heading size={HEADING_SIZE.SMALL}>Kijk zonder reclame, of extra voordelig mét reclame</Heading>
			<section className="tier-options-savod-selection-container">
				<div
					className={cx('tier-options-savod-selection__tier-without-ads', {
						['tier-options-savod-selection__tier-without-ads-selected']: !selectedSavodTier,
					})}
					onClick={() => {
						initiateTrackStructEvent({
							category: EVT_SUBSCRIPTION_CATEGORY,
							action: 'advertising-highlight',
							label: tierTitle,

							rtlElementContext: {
								elementInteraction: EVT_ELEMENT_INTERACTION,
								elementGroup: EVT_TIER_TABLE,
								elementType: EVT_ELEMENT_TYPE_BUTTON,
								elementName: 'advertising-tile',
								elementLabel: 'Zonder reclame',
								elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
							},
						});
						setProceedButtonUrl && setProceedButtonUrl(false);
						setSelectedSavodTier(false);
					}}
				>
					<span className="tier-options-savod-selection__tier-without-ads__text">
						Zonder reclame
					</span>
					<div
						className={cx('tier-options-savod__radio', {
							['tier-options-savod__radio--selected']: !selectedSavodTier,
						})}
					></div>
					<p className="tier-options-savod__price-container">
						<span className="tier-options-savod__price">&euro;{formatPrice(tierPrice)}</span>
						<span className="tier-options-savod__period">/ maand</span>
					</p>
				</div>
				<div>
					<div
						className={cx('tier-options-savod-selection__tier-without-ads', {
							['tier-options-savod-selection__tier-without-ads-selected']: selectedSavodTier,
						})}
						onClick={() => {
							initiateTrackStructEvent({
								category: EVT_SUBSCRIPTION_CATEGORY,
								action: 'advertising-highlight',
								label: tierTitle,

								rtlElementContext: {
									elementInteraction: EVT_ELEMENT_INTERACTION,
									elementGroup: EVT_TIER_TABLE,
									elementType: EVT_ELEMENT_TYPE_BUTTON,
									elementName: 'advertising-tile',
									elementLabel: 'Met reclame',
									elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
								},
							});
							setProceedButtonUrl && setProceedButtonUrl(true);
							setSelectedSavodTier(true);
						}}
					>
						<span className="tier-options-savod-selection__tier-without-ads__text">Met reclame <span>(voordeliger)</span></span>
						<div
							className={cx('tier-options-savod__radio', {
								['tier-options-savod__radio--selected']: selectedSavodTier,
							})}
						></div>
						<p className="tier-options-savod__price-container">
							<span className="tier-options-savod__price">&euro;{formatPrice(savodTierPrice)}</span>
							<span className="tier-options-savod__period">/ maand</span>
						</p>
					</div>
					<p className='tier-options-savod__duration'>Ongeveer 4 minuten reclame per uur</p>
				</div>
			</section>
			<div className="tier-options-savod__button-container">
				<Button
					kind={BUTTON_KIND_WHITE}
					onClick={() => {
						initiateTrackStructEvent({
							category: EVT_SUBSCRIPTION_CATEGORY,
							action: EVT_SUBSCRIPTION_SELECT,
							label: selectedSavodTier ? 'With commercials' : 'Without commercials',

							rtlElementContext: {
								elementInteraction: EVT_ELEMENT_INTERACTION,
								elementGroup: EVT_TIER_TABLE,
								elementType: EVT_ELEMENT_TYPE_BUTTON,
								elementName: EVT_TIER_TABLE_BUTTON,
								elementLabel: `Kies ${tierTitle}`,
								elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
							},
						});
						setIsSavodTierSelected(false);
						onClickProceed && onClickProceed(selectedTier, proceedText);
						proceedUrl && proceedToPushUrl(proceedUrl);
					}}
				>
					{`${proceedText} ${selectedSavodTier ? 'met reclame' : 'zonder reclame'}`}
				</Button>
				<span className="tier-options-savod__description">Zeg op wanneer jij dat wil.</span>
			</div>
		</div>
	);
};
